module.exports = __webpack_public_path__ + "img/dashboard-dark.6492c33a.webp";